import {useSearchParams} from 'next/navigation';

const useSearchParam = (
  key: string,
  defaultValue?: string,
  options: {push?: boolean} = {}
): [string, (value: string) => void] => {
  const searchParams = useSearchParams();

  const setParam = (newValue: string) => {
    const params = new URLSearchParams(document.location.search);

    if (newValue) {
      params.set(key, newValue);
    } else {
      params.delete(key);
    }

    const method = options.push ? window.history.pushState : window.history.replaceState;

    method(null, '', `?${params.toString()}`);
  };

  return [searchParams?.get(key) || defaultValue || '', setParam];
};

export const setSearchParam = (key: string, value: string, options: {push?: boolean} = {}) => {
  const params = new URLSearchParams(document.location.search);

  if (value) {
    params.set(key, value);
  } else {
    params.delete(key);
  }

  const method = options.push ? window.history.pushState : window.history.replaceState;

  method(null, '', `?${params.toString()}`);
};

export default useSearchParam;
